export default {
  methods: {
    transformDate(dateString) {
      const date = new Date(dateString);
      return date.toLocaleDateString('de-DE', {
        day: 'numeric', month: 'numeric', year: 'numeric',
      });
    },

    formatDateDDMMYYYY(dateStr) {
      const d = new Date(dateStr);

      const day = String(d.getDate()).padStart(2, '0');
      const month = String(d.getMonth() + 1).padStart(2, '0');
      const year = d.getFullYear();

      return `${day}.${month}.${year}`;
    }
  }
}
